<script>
import options from "./ContactCardBasic.options"
export default options
</script>

<template>
  <article class="nyk-contact-card nyk-contact-card-basic" :class="contactCardClassNames">
    <component
      :is="currentStepName"
      :nextStepCallback="validateInputAndProceed"
      :previousStepCallback="returnToPreviousStep"
      :displayInputError="displayInputError"
      :currentStepTexts="currentStepTexts"
      :currentStepOptions="currentStepOptions"
      :hasPreviousStep="hasPreviousStep"
      :resetSignupForm="resetSignupForm"
      :getNamedFieldInputData="getNamedFieldInputData"
      :showFieldErrorMessage="showFieldErrorMessage"
      :stepCounterText="stepCounterText"
      :imageSource="imageSource"
      :imageAltText="imageAltText"
      :labels="labels"
      :type="type"
      :redirectUrl="redirectUrl"
      :alwaysShowCprField="alwaysShowCprField"
    />
  </article>
</template>
